import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CustomTooltip = (props) => (
  <OverlayTrigger
    overlay={
      <Tooltip className="customTooltip" id={props.id}>
        {props.tooltip}
      </Tooltip>
    }
    placement={props.placement}
    delayShow={300}
    delayHide={150}
  >
    <span>{props.children}</span>
  </OverlayTrigger>
);

export default CustomTooltip;
